import { Component, Input, Output, EventEmitter, OnChanges, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ViewController, NavParams, App, AlertController } from 'ionic-angular';
import { RouteProvider } from '../../providers/route/route';
import { INavInfo } from '../../model/models/layout/nav-info.interface';
import { AuthProvider } from '../../providers/authorization/auth';
import { RmtPopupComponent } from '../rmt-popup/rmt-popup';
import { LoggerProvider } from '../../providers/logger/logger';
import { TranslateService } from '@ngx-translate/core';
import { IOrder } from '../../model/models/order/order-interface';
import { APP_CONFIG, Region } from '../../environment';
import { HelpProvider } from '../../providers/help/help';
import { ChatProvider } from '../../providers/zendesk/chat';
import { VueProvider } from '../../providers/vue/vue';
import { FeatureFlagTypes, UtilsProvider } from '../../providers/myria/utils-provider';
@Component({
  selector: 'rmt-app-bar',
  templateUrl: 'rmt-app-bar.html'
})
export class RmtAppBarComponent implements OnChanges, OnDestroy {
  @ViewChild('drag', { read: ElementRef }) drag: any;

  @Input() hasProfileNotification: boolean = false;

  @Input()
  private isFullHeight: boolean = false;

  @Input()
  private leftButtonType: string;

  @Input()
  private rightButtonType: string;

  @Input()
  private rightButtonIcon: string;

  @Input()
  private rightButtonText: string = '';

  @Input()
  private goToActivity: boolean = false;

  @Input()
  private goToLogin: boolean = false;

  @Input()
  private goToStart: boolean = false;

  @Input()
  private goToSendSummary: boolean = false;

  @Input()
  private goToProfileDocument: boolean = false;

  @Input()
  private closeLicensePage: boolean = false;

  @Input()
  private onBackCallback;

  @Input()
  private onHelpCallback;

  @Input()
  private border;

  @Output()
  private onRightButton = new EventEmitter<any>();

  @Input()
  titleId:string='';

  @Input()
  userBtnId:string='';

  @Input()
  onClose:any='';

  @Input()
  onBellClick:any = '';

  @Input()
  onShareClick:any = '';

  @Input()
  deleteClick:any = '';
  @Input() canShowReferralBtn: boolean = false;
  @Input() canSwitchToSmallReferralBtn: boolean = false;
  @Input() referralReward: string = '';
  @Input() onReferAFriendClick : any;

  @Input() showChatIcon: boolean = false;
  @Input() chatUnreadCount: number = 0
  @Input() onChatClick: any

  @Input()
  isShowSegmentButton: boolean = false;

  @Input()
  toggleButtonList: Array<any> = [];

  @Input()
  activeToggleVal: number = 0;
  @Input()
  newWalletUI: boolean = false;
  @Output() 
  toggleButtonClickEvent = new EventEmitter<string>();

  private backPage: INavInfo;
  private onBack;

  private order: IOrder = {};

  static app;
  static route;
  static translate;
  constructor(
    private app: App,
    private routeProvider: RouteProvider,
    private viewCtrl: ViewController,
    private navParams: NavParams,
    private translate: TranslateService,
    private authProvider: AuthProvider,
    private alertCtrl: AlertController,
    private chatProvider: ChatProvider,
    private vueProvider: VueProvider,
    private helpProvider: HelpProvider) {
    RmtAppBarComponent.app = this.app;
    RmtAppBarComponent.route = this.routeProvider;
    RmtAppBarComponent.translate = this.translate;

    this.backPage = this.navParams.get('backPage');
    this.onBack = this.navParams.get('onBack');
    this.order = this.navParams.get('order');
  }
  
  ngOnChanges() {
    this.hideLeftButton;
  }

  ngOnDestroy() {
    this.isFullHeight = false;
  }

  hideLeftButton() {
    if(this.isFullHeight) {
      this.leftButtonType = null;
    }
  }

  clickBack() {
    if (this.onBack)
      this.onBack(this.routeProvider);
    else if (this.onBackCallback)
      this.onBackCallback();
    else if (this.backPage) {
      this.routeProvider.replace(this.backPage);
    }
    else if(this.goToSendSummary){
      this.routeProvider.popTo(this.routeProvider.pages.SendSummaryPage);
    }
    else {
        RmtAppBarComponent.back();
    }
  }

  clickClose() {
    if(this.onClose)
      this.onClose();
    else if(this.goToActivity)
      this.routeProvider.setRoot(this.routeProvider.pages.TabsHomePage);
    else if (this.goToLogin)
      this.routeProvider.setRoot(this.routeProvider.pages.SigninPage);
    else if (this.goToStart) {
      if (this.routeProvider.hasPage(this.routeProvider.pages.SigninPage, true))
        this.routeProvider.popTo(this.routeProvider.pages.SigninPage);
      else
        this.routeProvider.setRoot(this.routeProvider.pages.PreLoginPage, {redirected: false});
    }
    else if(this.goToSendSummary){
      this.routeProvider.popTo(this.routeProvider.pages.SendSummaryPage);
    }
    else if(this.goToProfileDocument){
      if(this.routeProvider.hasPage(this.routeProvider.pages.SettingsIdPage)) this.routeProvider.popTo(this.routeProvider.pages.SettingsIdPage);
      else this.routeProvider.popTo(this.routeProvider.pages.SettingsPage);
    }
    else if (this.closeLicensePage)
      this.dismissLTLicenseModal();
    else
      this.viewCtrl.dismiss();
  }

  openHelp() {
    if(this.onHelpCallback){
      this.onHelpCallback();
    }else{
    this.helpProvider.openHelp();
    }
  }

  openProfile() {
    const rmt5VueBridgeProfileSettings = UtilsProvider.getFeatureFlagDataUnsafe(FeatureFlagTypes.Rmt5VueBridgeSettings);
    if (rmt5VueBridgeProfileSettings) {
      const biometricType = this.authProvider.faceId ? 'faceId' : 'touchId';
      this.vueProvider.navigate('ProfileSettingsHub', 'Activity', { biometricType }, () => {
        this.routeProvider.openModal(this.routeProvider.pages.SettingsPage);
      }, true);
      return;
    }
    this.routeProvider.openModal(this.routeProvider.pages.SettingsPage);
  }

  openMobileAppInbox() {
    this.onBellClick();
  }

  deleteBtnClick(){
    this.deleteClick();
  }

  shareBtnClick(){
    this.onShareClick();
  }

  clickSearch() {
    this.routeProvider.openModal(this.routeProvider.pages.ActivityFilterPage);
  }

  static back() {
    if(!this.app)
      return false;

    LoggerProvider.info(this, 'Pressed back button');

    const navCtrl = this.app.getActiveNavs()[0];
    const rootCtrl = this.app.getRootNavs()[0];
    if(navCtrl === this.route.getCurrentTab() && AuthProvider.isLoggedIn())
      return false;
    else if (navCtrl.canGoBack() || rootCtrl !== navCtrl)
      this.route.pop();
    else {
      let page = this.route.pages.PreLoginPage;
      if (AuthProvider.isLoggedIn())
        page = this.route.pages.TabsHomePage

      if (page.page === this.route.getLastActivePage()) {
        return false;
      }

      if (!AuthProvider.isLoggedIn() && this.route.getLastActivePage() !== this.route.pages.SigninPage.page)
        RmtPopupComponent.showErrorWithLogTranslation("page.errorPage.sessionExpired");

      this.route.setRoot(page);
    }
    return true;
  }

  dismissLTLicenseModal() {
    const confirm = this.alertCtrl.create({
      cssClass: "marketingConfirm",
      title: this.translate.instant("global.termsAgreementContainer.termsAgreementExitHeader"),
      message: this.translate.instant("global.termsAgreementContainer.termsAgreementExitContent"),
      buttons: [
        {
          text: this.translate.instant(
            "global.termsAgreementContainer.exitLogOutButton"
          ),
          cssClass: 'marketingButtonNo',
          handler: () => {
            this.authProvider.logoutUser();
          }
        },
        {
          text: this.translate.instant(
            "global.mFAContainer.genericCancelButton"
          ),
          cssClass: 'marketingButtonYes',
          handler: () => {
            confirm.dismiss();
          }
        }
      ]
    });
    confirm.setMode("ios");
    confirm.present();
  }

  rightButtonClick() {
    this.onRightButton.emit();

  }
  onReferAFriendBtnClick(){
    this.onReferAFriendClick();
  }

  openChat() {
    this.onChatClick();
  }

  startDragHeader(ev) {    
    let el = this.drag.nativeElement;
    while (el) {
      if (el.className && el.className.indexOf('ion-page') >= 0) {
        const ontouchmove = window.ontouchmove;
        const ontouchend = window.ontouchend;
        window.ontouchmove = (ev2: any) => {
          el.style.transition = '';
          el.style.transform = 'translateY('+ Math.abs(Math.min(0, ev.windowY - ev2.windowY)) + 'px)';          
        }
        window.ontouchend = (ev2: any) => {
          window.ontouchmove = ontouchmove;
          window.ontouchend = ontouchend;
          if ((ev.windowY - ev2.windowY) <= -100)
            this.viewCtrl.dismiss();
          else {
            el.style.transition = '150ms linear transform';
            el.style.transform = 'translateY(0px)';
          }
        }
        return;
      }
      el = el.parentNode;
    }

  }

  onSegmentChanged(props) {
    this.toggleButtonClickEvent.emit(props);
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-app-bar/rmt-app-bar.ts